import { z } from 'zod'

export const invoiceStatusSchema = z.enum([
  'CANCEL',
  'CANCEL_PAID',
  'CANCEL_NOSHOW_T',
  'NOSHOW_S',
  'NOSHOW_BOTH',
  'COMPLETED',
  'RESERVED',
  'PREFINISH',
])

export const diagnosisStatusSchema = z.enum([
  'NONE',
  'AVAILABLE',
  'REQUESTED',
  'FAILED',
  'COMPLETED',
  'FAILED_CRITICAL',
  'FAILED_MERGE',
  'FAILED_CHUNKING',
  'FAILED_FEEDBACK',
  'FAILED_QUESTION',
  'FAILED_CORRECTED',
  'PROCESSING',
])

export const cancelInvoiceStatusSchema = z.enum([
  invoiceStatusSchema.Enum.CANCEL_PAID,
  invoiceStatusSchema.Enum.CANCEL_NOSHOW_T,
  invoiceStatusSchema.Enum.NOSHOW_S,
  invoiceStatusSchema.Enum.NOSHOW_BOTH,
])

export const hideCancelInvoiceStatusSchema = z.enum([
  invoiceStatusSchema.Enum.COMPLETED,
  invoiceStatusSchema.Enum.PREFINISH,
])

export type InvoiceStatus = z.infer<typeof invoiceStatusSchema>
export type CancelInvoiceStatus = z.infer<typeof cancelInvoiceStatusSchema>
